import { useState } from 'react';
import * as Yup from 'yup';

export const useFormData = () => {
    const [formData, setFormData] = useState({
        subscriptionID: '',
        selectDevice: '',
        subscriptionStartsOn: '',
        subscriptionEndsOn: '',
        name: '',
        value: '',
        date: null,
        sms: '',
    });
    return { formData, setFormData };
};

export const validationForSelectedOrder = (subscriptionId,id) => {
    let validationshema = {}
    return validationshema = Yup.object({
        subscriptionID: !subscriptionId && !id && Yup.string().required('Kindly enter the Subscription ID'),
    });
}

export const validationForCancelOrder = (reason) => {
    let validationSchema = {}

    return validationSchema = Yup.object({
        reason: Yup.object().required("Select Reason"),
        comment: reason.value === "Other" && Yup.string().required('Enter Reason'),
    })
}